import React from 'react';
import styled from '@emotion/styled';
import { useFnReducer } from '@/src/hooks/utils';
import { Form, Input, InputNumber } from 'antd';

export interface BlockGroupPropsFormProps {

}
export interface BlockGroupPropsFormState extends BlockGroupPropsFormProps {
  name: string;
  groupWidth: number;
  groupHeight: number;
  blockSize: number;
}

const initState: BlockGroupPropsFormState = {
  name: '',
  blockSize: 32,
  groupHeight: 3,
  groupWidth: 3,
};

export interface BlockGroupPropsFormDispatch {
  setName: (name: string) => void;
  setGroupWidth: (width: number) => void;
  setGroupHeight: (height: number) => void;
  setBlockSize: (size: number) => void;
}

export type BlockGroupPropsFormStore = BlockGroupPropsFormState & BlockGroupPropsFormDispatch;

export function useBlockGroupPropsForm(): BlockGroupPropsFormStore {
  const [state, dispatch] = useFnReducer(initState);
  const setName = (name: string) => dispatch(state => ({ ...state, name }));
  const setGroupWidth = (groupWidth: number) => dispatch(state => ({ ...state, groupWidth }));
  const setGroupHeight = (groupHeight: number) => dispatch(state => ({ ...state, groupHeight }));
  const setBlockSize = (blockSize: number) => dispatch(state => ({ ...state, blockSize }));
  return {
    ...state,
    setGroupWidth,
    setGroupHeight,
    setBlockSize,
    setName,
  };
}

export function PureBlockGroupPropsForm(props: BlockGroupPropsFormStore) {
  const {
    blockSize,
    groupHeight,
    groupWidth,
    name,
    setBlockSize,
    setGroupHeight,
    setGroupWidth,
    setName,
  } = props;
  const {
    Container
  } = S;
  return (
    <Container>
      <Form>
        <Form.Item label={"名称"}>
          <Input value={name} onChange={e => setName(e.target.value)} />
        </Form.Item>
        <Form.Item label={"色块组尺寸"}>
          <InputNumber
            min={1}
            max={3}
            value={groupWidth}
            onChange={setGroupWidth}
          />
          <InputNumber
            min={1}
            max={3}
            value={groupHeight}
            onChange={setGroupHeight}
          />
        </Form.Item>
        <Form.Item label={"色块尺寸"}>
          <InputNumber value={blockSize} onChange={setBlockSize} />
        </Form.Item>
      </Form>
    </Container>
  );
}
const S = {
  Container: styled.div`
    padding: 16px;
  `,
}
export function BlockGroupPropsForm() {
  return <PureBlockGroupPropsForm {...useBlockGroupPropsForm()} />
}
